export const NEW_UID = 'NEW';
